import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { CommandSet } from '@shared/components/tree-data-table/commands/commands.model';
import { DataObject } from '@shared/models/data-object.model';
import { RowChange, SingleChange, SortMode } from '../complex-table.model';
import { ComplexTableStateService } from '../complex-table.service';
import { TableRowReorderEvent } from 'primeng/table';
import { EMPTY_STRING } from '@miq/utils';

@Component({
  selector: 'miq-child-table',
  templateUrl: './child-table.component.html',
  styleUrls: ['./child-table.component.scss'],
  standalone: false,
})
export class ChildTableComponent implements OnInit, OnChanges, OnDestroy {
  @Input() title: string;
  @Input() elements: any[];
  @Input() selectable = true;
  @Input() disableSelection = false;
  @Input() columns: any[];
  @Input() commands: CommandSet;
  @Input() parent: any;
  @Input() notify;
  @Input() tableService: ComplexTableStateService;
  @Input() clickableRow = false;
  @Input() showGoToRecordColumn = false;
  @Input() rowLinkGenerator: (x: DataObject) => string[] = null;

  @Input() sortable = false;
  @Input() sortMode: SortMode = SortMode.Default;
  @Input() sortMessage = EMPTY_STRING;

  @Output() rowClick = new EventEmitter<any>();
  @Output() childChange = new EventEmitter<RowChange | SingleChange>();
  @Output() clearSelection = new EventEmitter<any>();

  @Input() selectedItems: any[] = [];
  childSelected: any[] = [];
  @Output() selectedItemsChange = new EventEmitter<any[]>();
  @Output() rowReorderEvent = new EventEmitter<TableRowReorderEvent>();

  @ViewChild('parentRef', { static: true }) parentRef: any;

  ngOnInit() {
    this.commands = Object.entries(this.commands).reduce((acc, [key, commands]) => {
      return {
        ...acc,
        [key]: commands.map(commandObj => ({
          ...commandObj,
          command:
            typeof commandObj.command === 'string' ? commandObj.command : commandObj.command.bind(null, this.parent),
        })),
      };
    }, {});

    this.columns = this.columns.map(col => ({ ...col, height: 'auto' }));
  }

  ngOnChanges({ selectedItems }: SimpleChanges) {
    if (selectedItems && this.selectedItems) {
      this.childSelected = this.selectedItems.filter(selected => this.elements.indexOf(selected) > -1);
    }
  }

  handleChange($event, rowData, rowIndex) {
    this.childChange.emit({
      ...$event,
      rowData,
      rowIndex,
    });
  }

  clearSelectionAndCheckSelectionBlock() {
    this.selectedItemsChange.emit([]);
    this.tableService.unlockSelection();
  }

  onRowClick($event) {
    if (!!this.clickableRow) {
      this.rowClick.emit($event);
    }
  }

  handleInternalEvent(eventName: string, context: any[]) {
    return this.tableService.handleInternalEvent(this.elements, eventName, context);
  }

  ngOnDestroy() {
    this.parentRef = null;
  }
}
